import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var getUserWiseRes;
export const getUserWiseTodo = createAsyncThunk('getUserWise', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/get_users',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "group_data": val.group_data,
                "department_data": val.department_data,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return getUserWiseRes = res.data
    } catch (error) {
        return getUserWiseRes = error.response.data
    }
})


const getUserWiseSlice = createSlice({
    name: 'getUserWise',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(getUserWiseTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('getUserWise', state.data)
            }
        });
        builder.addCase(getUserWiseTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default getUserWiseSlice.reducer; 